import type { AppDispatch, RootState } from 'services/store/types';
import { eligibleTest } from '../../../network/api/project';
import { addToast } from '../toasts/actions';

export function EligibleTest() {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({ type: 'SEND_TEST_ELIGIBLE' });
      const { eligible } = getState();
      const value = {
        siren: eligible.siren,
        country: eligible.country,
      };
      const { data } = await eligibleTest(value);
      if (data?.info !== 'ok' && ['FR'].includes(eligible.country)) {
        setTimeout(() => dispatch({ type: 'TEST_ELIGIBLE_INVALID' }), 2000);
      } else {
        setTimeout(() => dispatch({ type: 'TEST_ELIGIBLE_SUCCESS' }), 2000);
      }
    } catch (err) {
      dispatch({ type: 'TEST_ELIGIBLE_FAILED' });
      dispatch(addToast({
        type: 'error',
        title: "Le test d'éligibilité est momentanément indisponible",
        description: `Une erreur technique est survenue lors de l'envoie de votre demande. ${err}`,
      }));
    }
  };
}

export function getSimulationData() {
  return async (dispatch: AppDispatch) => {
    const savedData = localStorage.getItem('eligible') || '{}';
    dispatch({ type: 'UPDATE_SIMULATION_DATA', payload: JSON.parse(savedData) });
  };
}
